import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import logo from "../assets/images/logoFWA.png";

export default function Header({ scrollToSection }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("accueil");
  const location = useLocation();
  const navigate = useNavigate();
  const activeMenuSection = location.pathname === "/" ? activeSection : "";
  const isBlogActive = location.pathname.startsWith("/blog");
  const isClientAreaActive = location.pathname === "/espace-client";

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const canScroll = typeof scrollToSection === "function" && location.pathname === "/";

  const menuItems = [
    { label: "Accueil", section: "accueil" },
    { label: "Services", section: "services" },
    { label: "Portfolio", section: "portfolio" },
    { label: "FAQ", section: "faq" },
    { label: "Contact", section: "contact" },
  ];

  const goToSection = (section) => {
    setActiveSection(section);
    if (canScroll) {
      scrollToSection(section);
    } else {
      navigate(`/#${section}`);
    }
  };

  return (
    <header className="header-nav bg-white shadow-md fixed w-full z-50">
      <div className="container flex items-center justify-between h-full p-2">
        <Link to="/" className="logo min-w-[50px]" onClick={() => setActiveSection("accueil")}>
          <img src={logo} alt="Fold Web Agency" style={{ margin: "5px", width: 150 }} />
        </Link>

        <nav className="hidden md:flex gap-2 items-center">
          {menuItems.map((item) => (
            <button
              key={item.section}
              onClick={() => goToSection(item.section)}
              className={`text-sm ${activeMenuSection === item.section ? "btn-primary" : "btn-secondary"}`}
            >
              {item.label}
            </button>
          ))}
          <Link
            to="/blog"
            onClick={() => setActiveSection("")}
            className={`text-sm ${isBlogActive ? "btn-primary" : "btn-secondary"}`}
          >
            Blog
          </Link>
          <Link
            to="/espace-client"
            onClick={() => setActiveSection("")}
            className={`text-sm ${isClientAreaActive ? "btn-primary" : "btn-secondary"}`}
          >
            Espace client
          </Link>
        </nav>

        <div className="md:hidden flex items-center">
          <button onClick={toggleMobileMenu} className="focus:outline-none">
            <div className="space-y-1">
              <span className="block w-6 h-0.5 bg-gray-800"></span>
              <span className="block w-6 h-0.5 bg-gray-800"></span>
              <span className="block w-6 h-0.5 bg-gray-800"></span>
            </div>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="absolute top-full right-0 w-48 bg-white shadow-md rounded-b-lg overflow-hidden z-10">
          {menuItems.map((item, index) => (
            <button
              key={item.section}
              onClick={() => {
                goToSection(item.section);
                setIsMobileMenuOpen(false);
              }}
              className={`w-full text-left px-4 py-3 ${
                activeMenuSection === item.section
                  ? "bg-black text-white hover:bg-gray-800"
                  : "bg-white text-gray-800 hover:bg-gray-100"
              } ${index !== menuItems.length - 1 ? "border-b border-gray-200" : ""}`}
            >
              {item.label}
            </button>
          ))}
          <Link
            to="/blog"
            onClick={() => {
              setActiveSection("");
              setIsMobileMenuOpen(false);
            }}
            className={`block w-full text-left px-4 py-3 border-b border-gray-200 ${
              isBlogActive
                ? "bg-black text-white hover:bg-gray-800"
                : "bg-white text-gray-800 hover:bg-gray-100"
            }`}
          >
            Blog
          </Link>
          <Link
            to="/espace-client"
            onClick={() => {
              setActiveSection("");
              setIsMobileMenuOpen(false);
            }}
            className={`block w-full text-left px-4 py-3 ${
              isClientAreaActive
                ? "bg-black text-white hover:bg-gray-800"
                : "bg-white text-gray-800 hover:bg-gray-100"
            }`}
          >
            Espace client
          </Link>
        </div>
      )}
    </header>
  );
}
